module.exports = __webpack_public_path__ + "img/logo.217d7047.svg";